module.exports = __webpack_public_path__ + "img/microplastics-process-9.2308ccc7.png";